import React, { FC } from 'react';
import { Button, Modal, Spinner } from 'react-bootstrap';

export interface Props {
  closeSettings: () => void;
  buttons?: Array<{ text: string; loading?: boolean; buttonVariant: string; onClick: () => void; disabled?: boolean }>;
  show: boolean;
  modalHeading: string;
  children?: React.ReactNode;
  modalSize?: 'sm' | 'lg' | 'xl';
  className?: string;
}

const ModalComponent: FC<Props> = ({
  closeSettings,
  buttons,
  show,
  modalHeading,
  children,
  modalSize,
  className,
}: Props) => {
  return (
    <Modal
      show={show}
      size={modalSize}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      onHide={() => closeSettings()}
      data-testid="modal-test"
      className={className}
    >
      <Modal.Header closeButton>
        <Modal.Title>{modalHeading}</Modal.Title>
      </Modal.Header>
      <Modal.Body className={className}>{children}</Modal.Body>
      {buttons && buttons.length > 0 && (
        <Modal.Footer>
          {buttons.map((button) => {
            if (button.loading) {
              return (
                <Button disabled key={button.text} variant={button.buttonVariant}>
                  <Spinner animation="border" size="sm" /> {button.text}
                </Button>
              );
            }
            return (
              <Button
                key={button.text}
                variant={button.buttonVariant}
                onClick={button.onClick}
                disabled={button.disabled}
              >
                {button.text}
              </Button>
            );
          })}
        </Modal.Footer>
      )}
    </Modal>
  );
};

export default ModalComponent;
